import { render, staticRenderFns } from "./AboutStyleThree.vue?vue&type=template&id=6b68279a&"
import script from "./AboutStyleThree.vue?vue&type=script&lang=js&"
export * from "./AboutStyleThree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports